import React, { useState } from "react";
import { Col, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import "./searchbar.css";

function Search_Bar(props) {
  const [Search, setSearch] = useState([]);

  // const searchHandler = (searchText) => {
  //   if (searchText.length > 0) {
  //     let search = props?.ActualData?.filter((item) => {
  //        console.log("item***********", item);
  //       let name = item?.UserName ? item?.UserName : item?.FullName;
  //       const textData = (name?.toString())?.toLowerCase();
  //       let searchData = (searchText?.toString())?.toLowerCase();
  //       // return textData?.indexOf(searchData) > -1;
  //       return textData.includes(searchData);
  //     });
  //     setSearch(search);
  //     // props.setData(Search);
  //     props.setData(search);
  //   } else {
  //     props.setData(props.ActualData);
  //   }
  // };
  
  
  const searchHandler = (searchText) => {
    if (searchText.length > 0) {
      
    const search = props?.ActualData?.filter((item) =>
    
    (item?.UserName?.toString())?.toLowerCase().includes((searchText?.toString())?.toLowerCase()) ||
    (item?.FullName?.toString())?.toLowerCase().includes((searchText?.toString())?.toLowerCase()) ||
    (item?.EmailAddress?.toString())?.toLowerCase().includes((searchText?.toString())?.toLowerCase()) ||
    (item?.Profiles?.FirstName?.toString())?.toLowerCase().includes((searchText?.toString())?.toLowerCase()) ||
    (item?.Profiles?.LastName?.toString())?.toLowerCase().includes((searchText?.toString())?.toLowerCase()) 
      
          )
    
    setSearch(search); 
    props.setData(search);
  } 
  
  else {
    props.setData(props.ActualData);
  }
};
  


  
  return (
    <div>
      <Col lg={8} md={8} sm={8} xs={24}>
        <Input
          className="teamlisting-inp"
          type="input"
          placeholder="Search"
          prefix={<SearchOutlined className="teamlisting-searchicon" />}
          style={{ marginTop: "2px" }}
          // suffix={"+"}
          allowClear={true}
          onChange={(e) => searchHandler(e.target.value)}
        />
      </Col>
    </div>
  );
}

export default Search_Bar;
